module.exports = __webpack_public_path__ + "media/no_photo.ae16a930.jpg";